import React from 'react';
import emailjs from 'emailjs-com';
import Footer from './Footer';
import TeamChat from '../assets/images/team_chat.svg'

const Email = () => {

	function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('gmail', 'template_gh32tbn', e.target, 'user_hwZyinxTi8SP0y1Y1sna1')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset()
    }

    return (
      <>
        <section id="emailus">
          <div className="container">
            <div className="row">
              <div className="col col-md-12 text-center">
                <h2 className="text-dark">Let Us Know Your Idea</h2>
                <hr className="my-4 mx-auto" />
                <p>We are excited to hear you. And we'll get back to you real soon.</p>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row d-flex justify-content-around align-items-center">
              <div className="col-md-6 shadow bg-info rounded-circle">
                <img className="chat_image" src={TeamChat} alt="Let's Talk"/>
              </div>
              <div className="col-md-5 order-md-first text-left">
                <form className="contact_form" onSubmit={sendEmail}>
                  <div className="form-group py-1">
                    <label htmlFor="name">Your Name</label>
                    <input type="text" name="name" className="form-control" id="name" placeholder="Name" required/>
                  </div>
                  <div className="form-group py-1">
                    <label htmlFor="email">Email Address</label>
                    <input type="email" name="email" className="form-control" id="email" placeholder="name@example.com" required/>
                  </div>
                  <div className="form-group py-1">
                    <label htmlFor="phone">Phone Number</label>
                    <input type="number" name="phone" className="form-control" id="phone" placeholder="Phone" required/>
                  </div>
                  <div className="form-group py-1">
                    <label htmlFor="subject">Subject</label>
                    <input type="text" name="subject" className="form-control" id="subject" placeholder="Subject" required/>
                  </div>
                  <div className="form-group py-1">
                    <label htmlFor="idea">Your Idea</label>
                    <textarea name="message" className="form-control" id="idea" rows="3" required></textarea>
                  </div>
                  <div className="form-group py-2">
                    <input className="btn btn-warning" type="submit" value="Send Message"/>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </>
    )
}

export default Email